export enum FileRotationStatus {
  initialized = 'initialized',
  processing = 'processing',
}
